export const RegulationsType = {
  Regulations: "regulations",
  PrivacyPolicy: "privacyPolicy",
  InfoClause: "informationClause",
  TrainingRegulations: "training",
};
